import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';
import { CSSProperties } from 'react';

export default function BeneficiosChippuMobileFallback(props: {
  style?: CSSProperties;
}) {
  const { style } = props;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing[3],
        overflow: 'hidden',
        ...style,
      }}
    >
      <Skeleton
        style={{
          height: 144,
          backgroundColor: theme.tokens.colors.chippu_benefit_background,
          backdropFilter: 'blur(42px)',
        }}
      />
      <Skeleton
        style={{
          height: 144,
          backgroundColor: theme.tokens.colors.chippu_benefit_background,
          backdropFilter: 'blur(42px)',
        }}
      />
      <Skeleton
        style={{
          height: 144,
          backgroundColor: theme.tokens.colors.chippu_benefit_background,
          backdropFilter: 'blur(42px)',
        }}
      />
      <Skeleton
        style={{
          height: 144,
          backgroundColor: theme.tokens.colors.chippu_benefit_background,
          backdropFilter: 'blur(42px)',
        }}
      />
    </div>
  );
}
